export const FIREBASE_AUTH_EMAIL_ALREADY_IN_USE = 'auth/email-already-in-use'
